var map = {
	"./404.svg": [
		28190,
		8190
	],
	"./AI.svg": [
		63805,
		3805
	],
	"./Add2.svg": [
		13269,
		3269
	],
	"./AddCircle2.svg": [
		35600,
		5600
	],
	"./AlertCircle.svg": [
		94967,
		4967
	],
	"./AlertTriangle.svg": [
		9573,
		9573
	],
	"./ArrowCircleDown.svg": [
		92875,
		2875
	],
	"./ArrowCircleLeft.svg": [
		78929,
		8929
	],
	"./ArrowCircleRight.svg": [
		6603,
		6603
	],
	"./ArrowCircleUp.svg": [
		11070,
		1070
	],
	"./ArrowDown.svg": [
		77929,
		7929
	],
	"./ArrowLeft.svg": [
		31389,
		1389
	],
	"./ArrowLeftRight.svg": [
		29771,
		9771
	],
	"./ArrowReset.svg": [
		22991,
		2991
	],
	"./ArrowRight.svg": [
		84469,
		4469
	],
	"./ArrowUp.svg": [
		46399,
		6399
	],
	"./Attach2.svg": [
		71779,
		1779
	],
	"./AvyIconFilled.svg": [
		5197,
		5197
	],
	"./Bank2.svg": [
		29818,
		9818
	],
	"./BankID.svg": [
		51024,
		1024
	],
	"./BellOutlined2.svg": [
		47859,
		7859
	],
	"./BellOutlinedEmpty.svg": [
		28290,
		8290
	],
	"./BellOutlinedOff2.svg": [
		54259,
		4259
	],
	"./BicyclePurchase.svg": [
		49727,
		9727
	],
	"./BicycleRent.svg": [
		28605,
		8605
	],
	"./BicycleStorage.svg": [
		96969,
		6969
	],
	"./Blizz2.svg": [
		69098,
		9098
	],
	"./Blueprint.svg": [
		37252,
		7252
	],
	"./Boplats.svg": [
		59370,
		9370
	],
	"./BoxStorage2.svg": [
		19664,
		9664
	],
	"./BoxStorageFilled.svg": [
		56185,
		6185
	],
	"./Building2.svg": [
		84121,
		4121
	],
	"./Buildings2.svg": [
		63605,
		3605
	],
	"./BulbOutlined2.svg": [
		38610,
		8610
	],
	"./Bullet.svg": [
		3054,
		3054
	],
	"./BusinessCard.svg": [
		66297,
		6297
	],
	"./CalendarAdd.svg": [
		46627,
		6853
	],
	"./CalendarAdd2.svg": [
		5627,
		5627
	],
	"./CalendarDate.svg": [
		78720,
		8720
	],
	"./CalendarDone.svg": [
		20058,
		58
	],
	"./CalendarEdit.svg": [
		96361,
		6361
	],
	"./CalendarEmpty.svg": [
		76541,
		6541
	],
	"./CalendarFavorite.svg": [
		4849,
		4849
	],
	"./CalendarLocked.svg": [
		53152,
		3152
	],
	"./CalendarTime.svg": [
		26618,
		6618
	],
	"./CameraOutlined2.svg": [
		25890,
		5890
	],
	"./CameraVideoOutlined.svg": [
		47915,
		5995
	],
	"./Car2.svg": [
		99893,
		9893
	],
	"./ChatTranslate.svg": [
		50608,
		608
	],
	"./CheckCircle2.svg": [
		65673,
		5673
	],
	"./CheckCircleFilled2.svg": [
		91514,
		1514
	],
	"./CheckSimple.svg": [
		51987,
		1987
	],
	"./CheckSquareFilled.svg": [
		51727,
		1727
	],
	"./Checklist2.svg": [
		52060,
		2060
	],
	"./ChevronDown.svg": [
		27887,
		7887
	],
	"./ChevronLeft.svg": [
		14468,
		4468
	],
	"./ChevronRight.svg": [
		48970,
		8970
	],
	"./ChevronUp.svg": [
		49555,
		9555
	],
	"./Cleaning.svg": [
		79310,
		9310
	],
	"./Close.svg": [
		50162,
		162
	],
	"./CloudDownload.svg": [
		80010,
		10
	],
	"./CloudUpload.svg": [
		39316,
		9316
	],
	"./Coins.svg": [
		26627,
		6627
	],
	"./Community.svg": [
		11486,
		1486
	],
	"./Copy2.svg": [
		61614,
		1614
	],
	"./Dashboard.svg": [
		86308,
		6308
	],
	"./DeclarationOfInterest.svg": [
		80532,
		532
	],
	"./DigitalLetter.svg": [
		76552,
		6552
	],
	"./Document2.svg": [
		28555,
		8555
	],
	"./DocumentContract.svg": [
		85742,
		5742
	],
	"./DocumentTermination.svg": [
		92121,
		2121
	],
	"./Download.svg": [
		63152,
		9168
	],
	"./Edit2.svg": [
		41214,
		1214
	],
	"./EmptyNest.svg": [
		56034,
		6034
	],
	"./Envelope2.svg": [
		53595,
		3595
	],
	"./Exchange.svg": [
		34298,
		4298
	],
	"./Express2.svg": [
		92542,
		2542
	],
	"./Filter2.svg": [
		91627,
		1627
	],
	"./Fire2.svg": [
		21690,
		1690
	],
	"./Flag.svg": [
		71502,
		1502
	],
	"./GlobeOutlined2.svg": [
		46313,
		6313
	],
	"./GoogleTranslate.svg": [
		77674,
		7674
	],
	"./Graph2.svg": [
		17750,
		7750
	],
	"./HeartLarge.svg": [
		94394,
		4394
	],
	"./Hide.svg": [
		93035,
		3035
	],
	"./House2.svg": [
		6073,
		6073
	],
	"./HouseLoan.svg": [
		68276,
		8276
	],
	"./HouseUser2.svg": [
		92492,
		2492
	],
	"./HouseUsers2.svg": [
		73812,
		3812
	],
	"./Hyperlink2.svg": [
		12498,
		2498
	],
	"./ImageError.svg": [
		93321,
		3321
	],
	"./Info.svg": [
		90694,
		694
	],
	"./Invoice.svg": [
		22707,
		2707
	],
	"./It services.svg": [
		87272,
		7272
	],
	"./KeyOutlined2.svg": [
		9475,
		9475
	],
	"./LaundryMachine2.svg": [
		21138,
		1138
	],
	"./LibraryBook2.svg": [
		71313,
		1313
	],
	"./LikeFilled.svg": [
		31812,
		1812
	],
	"./LikeOutlined.svg": [
		99115,
		9115
	],
	"./Loading.svg": [
		56741,
		6741
	],
	"./Lock2.svg": [
		90372,
		372
	],
	"./LogOut.svg": [
		22181,
		2181
	],
	"./Login 2.svg": [
		21858,
		1858
	],
	"./MapPin2.svg": [
		57824,
		7824
	],
	"./MapTack2.svg": [
		14744,
		4744
	],
	"./Mastercard.svg": [
		71352,
		1352
	],
	"./MenuHamburgerClosed.svg": [
		10047,
		47
	],
	"./MenuMeatballs.svg": [
		88812,
		8812
	],
	"./MessageBubbleSquareOutlined2.svg": [
		65653,
		5653
	],
	"./NoticeBoard.svg": [
		85222,
		5222
	],
	"./Offer.svg": [
		7605,
		7605
	],
	"./OpenInWeb.svg": [
		92462,
		2462
	],
	"./PDF2.svg": [
		88262,
		8262
	],
	"./Parking2.svg": [
		58951,
		8951
	],
	"./Pay.svg": [
		16175,
		6175
	],
	"./Pencil2.svg": [
		41183,
		1183
	],
	"./Phone2.svg": [
		78531,
		8531
	],
	"./PictureMultiple2.svg": [
		35455,
		5455
	],
	"./PictureSingle2.svg": [
		89884,
		9884
	],
	"./Plant2.svg": [
		38481,
		8481
	],
	"./PlantMonstera2.svg": [
		46633,
		6633
	],
	"./QuestionCircle.svg": [
		26424,
		6424
	],
	"./QuestionCircleOutlined2.svg": [
		44722,
		4722
	],
	"./Relocation.svg": [
		34551,
		4551
	],
	"./RemoveCircle2.svg": [
		12063,
		2063
	],
	"./RemoveCircleOutlined2.svg": [
		17787,
		7787
	],
	"./ResizeExpandSize.svg": [
		66233,
		6233
	],
	"./Router.svg": [
		42651,
		9897
	],
	"./SavingPiggyBank2.svg": [
		31926,
		1926
	],
	"./Search.svg": [
		25528,
		5528
	],
	"./SecondhandContract.svg": [
		35565,
		5565
	],
	"./Send2.svg": [
		79267,
		9267
	],
	"./Services.svg": [
		59517,
		9517
	],
	"./Settings2.svg": [
		21179,
		1179
	],
	"./Share.svg": [
		1957,
		1957
	],
	"./ShieldHeart.svg": [
		65796,
		5796
	],
	"./ShieldHome2.svg": [
		46187,
		6187
	],
	"./ShieldHomeFilled.svg": [
		68244,
		8244
	],
	"./ShoppingBasket.svg": [
		4573,
		4573
	],
	"./ShoppingCart.svg": [
		7311,
		7311
	],
	"./Show.svg": [
		76989,
		6989
	],
	"./Sickness2.svg": [
		74718,
		4718
	],
	"./Smartphone.svg": [
		78581,
		8581
	],
	"./Springboard.svg": [
		17655,
		7655
	],
	"./Stairway2.svg": [
		34105,
		4105
	],
	"./StarFilled2.svg": [
		44807,
		4807
	],
	"./StarOutlined2.svg": [
		21083,
		1083
	],
	"./StarRibbon.svg": [
		77138,
		7138
	],
	"./StatusIndicator.svg": [
		55278,
		5278
	],
	"./Stop.svg": [
		93354,
		3354
	],
	"./Stopwatch2.svg": [
		66400,
		6400
	],
	"./Storage.svg": [
		60722,
		722
	],
	"./SubtractCircle2.svg": [
		60602,
		602
	],
	"./Success.svg": [
		79881,
		9881
	],
	"./Support2.svg": [
		47760,
		7760
	],
	"./Survey2.svg": [
		23637,
		3637
	],
	"./Tasklist2.svg": [
		8095,
		2553
	],
	"./Temperature.svg": [
		27291,
		7291
	],
	"./TimeClock2.svg": [
		88516,
		8516
	],
	"./Tool.svg": [
		84741,
		4741
	],
	"./TrashBin2.svg": [
		89549,
		9549
	],
	"./Tree2.svg": [
		9174,
		9174
	],
	"./UnLikeOutlined.svg": [
		40273,
		273
	],
	"./Unemployment2.svg": [
		9233,
		9233
	],
	"./UnlikeFilled.svg": [
		12261,
		2261
	],
	"./User2.svg": [
		11249,
		1249
	],
	"./UsersFriends.svg": [
		8279,
		8279
	],
	"./View2.svg": [
		13831,
		3831
	],
	"./ViewHidden2.svg": [
		56799,
		6799
	],
	"./WalletOutlined2.svg": [
		42171,
		2171
	],
	"./Wifi2.svg": [
		3929,
		3929
	],
	"./Wrench2.svg": [
		56631,
		6631
	],
	"./ZoomIn.svg": [
		31662,
		1662
	],
	"./ZoomOut.svg": [
		2331,
		2331
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 69439;
module.exports = webpackAsyncContext;